import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {useShowHotelDatePickerOverlay} from 'hooks/useShowOverlay/useShowOverlay'
import {getCurrencyCode} from 'modules/meta/selectors'
import {DateGuestPickerSource} from 'modules/overlay/types'
import {setOpenDatePickerType} from 'modules/searchBox/slice'
import {DatePickerType} from 'modules/searchBox/types'

import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Card} from '@vio/atlas/src/components/designSystem/Card'
import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {cssTheme} from '@vio/atlas/src/themes'
import {Team} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {
  MessageWrapper,
  PriceComposition
} from '@vio/shared/src/search/PriceComposition'

const StyledPriceComposition = styled(PriceComposition)`
  ${MessageWrapper} {
    ${cssTheme.typography.bodyS}
    color: ${cssTheme.colors.content.neutral.primary};
  }
`

interface DatelessOfferBoxProps {
  priceFrom?: number
}

export const DatelessOfferBox = ({priceFrom}: DatelessOfferBoxProps) => {
  const dispatch = useDispatch()
  const showHotelDatePickerOverlay = useShowHotelDatePickerOverlay()
  const {isMobile} = useDeviceLayout()
  const currencyCode = useSelector(getCurrencyCode)

  const openDatePicker = () => {
    if (isMobile) {
      showHotelDatePickerOverlay(
        DatePickerType.CheckIn,
        Team.Default,
        DateGuestPickerSource.AccommodationPageSearch
      )
      return
    }
    dispatch(setOpenDatePickerType(DatePickerType.CheckIn))
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  return (
    <Card
      dataId="datelessOfferBox"
      borderRadius="lg"
      backgroundColorPath="background.brand.tertiary"
      borderColorPath="border.neutral.secondary"
    >
      <Box
        display="flex"
        flexDirection="column"
        paddingTop="s400"
        paddingBottom="s400"
        paddingLeft="s500"
        paddingRight="s500"
        gap="s500"
      >
        <div>
          <Box marginBottom="s400">
            <Text variant="labelS">
              <FormattedMessageWrapper
                id="selectDatesToContinue"
                defaultMessage="Select dates to continue"
              />
            </Text>
          </Box>
          {priceFrom && (
            <>
              <Text variant="bodyS" colorPath="content.neutral.secondary">
                <FormattedMessageWrapper id="From" defaultMessage="From" />
              </Text>
              <StyledPriceComposition
                size="xl"
                anchorPrice={undefined}
                currencyCode={currencyCode}
                price={priceFrom}
                showIndication
              />
            </>
          )}
        </div>
        <Button variant="primary" size="lg" fullWidth onClick={openDatePicker}>
          <FormattedMessageWrapper
            id="datePicker.selectDates"
            defaultMessage="Select dates"
          />
        </Button>
      </Box>
    </Card>
  )
}
